<main *ngIf="removeModel">
    <section class="enrollment-tool-page">
        <form [formGroup]="selectionTool" name="selectionTool">
            <div class="form-group">
                <div class="row">
                    <h1 class="col-sm-12 col-md-6 col-md-offset-3 enroll-tool-header">
                        <strong> {{this.removeModel.removeTool.header}} </strong></h1>
                </div>
                <div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-md-offset-3">
                            <div *ngIf="errorMessage" class="alert valign-children-middle error-container">
                                <div class="alert-error" role="img">
                                    <i class="icon-badgealert" aria-label="alert"></i>
                                </div>
                                <div>{{errorMessage}}</div>
                            </div>
                            <p class="subHeader">{{this.removeModel.removeTool.details}}</p>

                            <div class="flex-container">
                                <div class="chart-container">
                                    <app-donut-chart *ngIf="donutChartData" [data]="donutChartData" [r]='chartRadius' [label]="chartLabel"
                                        [stroke_width]='strokeWidth' [error]="chartError">
                                    </app-donut-chart>

                                </div>
                                <div class="chart-legend-container chart-legends">
                                    <app-legend *ngIf="!chartError" [data]="donutChartData"></app-legend>
                                </div>
                            </div>
<br/>
                            <!-- <hr /> -->
                            
                            <!-- remove accounts -->
                            <fieldset class="fieldset">
                                <legend class="offscreen">{{this.removeModel.removeTool.remove}}</legend>

                                <div class="setupContainer">

                                    <label class="radio list-buttons" *ngIf="ztplistcount > 0">
                                        <input type="radio" class="gIdremove gIdPerm" id="gIdremove" value="DMPGZTPremove"
                                            aria-labelledby="remove" name="toolSelection" 
                                            (click)="toolSelectedztp($event)" [checked]="selectedProgram === 'DMPGZTP' && flag === true">
                                        <i class="skin"></i>
                                        <span class="subLabel subLabelAndroid"
                                            id="subLabelGid">{{this.removeModel.removeTool.android}}</span>
                                    </label>
                                    <!-- <br />
                                    <br/> -->

                                    <label class="radio list-buttons" *ngIf="abmlistcount > 0">
                                        <input type="radio" class="aIdremove aIdPerm" id="aIdremove" value="DMPAABMremove"
                                            aria-labelledby="remove" name="toolSelection" 
                                             (click)="toolSelectedabm($event)"  [checked]="selectedProgram === 'DMPAABM' && flag === true">
                                        <i class="skin"></i>
                                        <span class="subLabel subLabelApple"
                                            id="subLabelAid">{{this.removeModel.removeTool.apple}}</span>
                                    </label>
<!-- <br/>
<br/> -->
                                    <label class="radio list-buttons" *ngIf="kmelistcount > 0">
                                        <input type="radio" class="sIdremove sIdPerm" id="sIdremove" value="DMPSKMEremove"
                                            aria-labelledby="remove" name="toolSelection" 
                                             (click)="toolSelectedkme($event)"  [checked]="selectedProgram === 'DMPSKME'&& flag === true">
                                        <i class="skin"></i>
                                        <span class="subLabel subLabelSamsung"
                                            id="subLabelSid">{{this.removeModel.removeTool.samsung}}</span>
                                    </label>
                                    <!-- <br />
                                    <br/> -->
                                    <!-- <span class="selectedDetailsKmeremove oemDetails"
                                        id="selectedDetailsKmeremove">{{this.removeModel.removeTool.kmeLabel}}
                                        {{selectedDetailsKme}}</span> -->

                                </div>
                            </fieldset>
                            <hr />
                            <div class="row live">
                                <div class="col-sm-12 col-md-12 text-right">
                                    <button aria-label="continue" (click)="continue()" [disabled]="!optselected"
                                        class="btn btn-secondary pull-right validation"
                                        id="validation">{{this.removeModel.removeTool.continue}}</button>
                                    <a href="javascript:void(0)" (click)="cancel()"
                                        class="btn btn-link btn-block btn-cancel">{{this.removeModel.removeTool.back}}</a>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </section>
</main>
<!-- <app-mobile-pivot [pivots]="pivots"></app-mobile-pivot> -->